import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberDashboardPage from "@/pages/member/MemberDashboardPage";

export const Route = createFileRoute("/member/dashboard")({
  head: () => pageHead("Member · Dashboard", "AKIVA member · dashboard portal.", "/member/dashboard", true),
  component: MemberDashboardPage,
});
